import { Mail, MessageCircle, MessageSquare, Phone } from 'lucide-react';
import { SocialLogo } from '../ui';

/** The outreach channels' marks — shared by the map's outreach column and the Channels-out settings list:
 *  brand logos where the app ships them, lucide glyphs for the rest. Draws at 24 in `currentColor`. */
export function OutreachChannelGlyph({ slug }: { slug: string }) {
  switch (slug) {
    case 'instagram':
      return <SocialLogo network="INSTAGRAM" size={24} />;
    case 'x':
      return <SocialLogo network="X" size={24} />;
    case 'messenger':
      return <SocialLogo network="FACEBOOK" size={24} />;
    case 'email':
      return <Mail size={24} aria-hidden />;
    case 'phone':
      return <Phone size={24} aria-hidden />;
    case 'sms':
    case 'imessage':
      return <MessageSquare size={24} aria-hidden />;
    case 'whatsapp':
    default:
      return <MessageCircle size={24} aria-hidden />;
  }
}
